import React from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  type SxProps,
  type Theme,
} from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";
import { useFilterBarContext } from "./filterBarContext";

export const FILTER_HEIGHT = 40;
export const FILTER_INPUT_HEIGHT = 39;
export const FILTER_WIDTH = 220;

export interface FilterFieldProps {
  source: string;
  label: string;
  name?: string;
  sx?: SxProps<Theme>;
}

const FilterField: React.FC<FilterFieldProps> = ({
  source,
  label,
  name,
  sx,
}) => {
  const { pendingValues, setPendingValue, registerLabel } =
    useFilterBarContext();
  const value = (pendingValues[source] as string | undefined) ?? "";

  React.useEffect(() => {
    registerLabel(source, label);
  }, [source, label, registerLabel]);

  return (
    <TextField
      name={name ?? source}
      label={label}
      value={value}
      onChange={(e) => setPendingValue(source, e.target.value)}
      size="small"
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => setPendingValue(source, "")}
              edge="end"
              aria-label="clear"
              sx={{ mr: -0.5 }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{
        width: { xs: "100%", sm: FILTER_WIDTH },
        flexShrink: 0,
        "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
          height: FILTER_INPUT_HEIGHT,
          minHeight: FILTER_INPUT_HEIGHT,
        },
        "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiOutlinedInput-input": {
          py: 0,
        },
        ...(sx as object),
      }}
    />
  );
};

export default FilterField;
